import { render } from "./ProductCardComponent.vue?vue&type=template&id=768c4dea&scoped=true"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"

import "./ProductCardComponent.vue?vue&type=style&index=0&id=768c4dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768c4dea"]])

export default __exports__